import { DateTime } from 'luxon';

export const APPLICATION_TIME_ZONE = 'Europe/Berlin';

export function toApplicationDateTime(
  value: unknown
): DateTime {
  if (DateTime.isDateTime(value)) {
    return value.setZone(APPLICATION_TIME_ZONE);
  }
  if (value instanceof Date) {
    return DateTime.fromJSDate(value).setZone(
      APPLICATION_TIME_ZONE
    );
  }
  if (typeof value === 'number') {
    return DateTime.fromMillis(value).setZone(
      APPLICATION_TIME_ZONE
    );
  }
  if (typeof value === 'string') {
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return DateTime.fromISO(value, {
        zone: APPLICATION_TIME_ZONE,
      });
    }
    return DateTime.fromISO(value, {
      setZone: true,
    }).setZone(APPLICATION_TIME_ZONE);
  }
  return DateTime.invalid('Invalid date value');
}

export function getApplicationTimeZoneName(
  dateTime: DateTime
): 'CET' | 'CEST' {
  return dateTime.setZone(APPLICATION_TIME_ZONE).isInDST
    ? 'CEST'
    : 'CET';
}
